/**
 * Sub Pub
 */
const subscriptions = {}
const getNextUniqueId = _getIdGenerator()

export function subscribe (eventType, callback, scope) {
  const id = getNextUniqueId()

  if (!subscriptions[eventType]) {
    subscriptions[eventType] = {}
  }

  subscriptions[eventType][id] = {
    scope: scope,
    callback: callback
  }

  return { 
    unsubscribe: () => {
      delete subscriptions[eventType][id]

      if (Object.keys(subscriptions[eventType]).length === 0) {
        delete subscriptions[eventType]
      }
    }
  }
}

export function publish(eventType, arg, scopes) {
  if (!subscriptions[eventType]) {
    return
  }

  Object.entries(subscriptions[eventType]).map((sub) => {
    if(scopes.indexOf(sub[1].scope) >= 0) {
      sub[1].callback(arg)
    }
  })
}

function _getIdGenerator() {
  let lastId = 0
  
  return function getNextUniqueId() {
      lastId += 1
      return lastId
  }
}